export function getStopHoverPosition(x, y, leftColumnsWidth) {
  const marginTopSpacing = 30;
  const stopHoverWidth = 441;
  const topBarsSpacing = 94;
  const sideBarSpacing = 50;
  const scrollRightWidth = 10;
  const barsSpacing = 69;
  const maxHeightHover = 326;
  const arrowWidth = 20;
  const hoverTopMax = marginTopSpacing + y;
  const bottomLimit = maxHeightHover + hoverTopMax + barsSpacing;

  const realBoundLeft = x - sideBarSpacing;
  const realBoundRight = x - sideBarSpacing;
  const realBoundTop = y - topBarsSpacing;

  const bottomPosition = realBoundTop + (marginTopSpacing / 2) + 10;
  const topPosition = realBoundTop - maxHeightHover - marginTopSpacing;

  const hasBottomSpaceOnWindow = window.innerHeight < bottomLimit;
  const hoverSide = hasBottomSpaceOnWindow ? 'top' : 'bottom';

  const maxLeft = x + (stopHoverWidth / 2) - scrollRightWidth;
  const minLeft = realBoundLeft - (stopHoverWidth / 2);
  const hasRightSpaceOnWindow = maxLeft < window.innerWidth;
  const hasLeftSpaceOnWindow = minLeft >= leftColumnsWidth - 20;

  const hoverAlign = () => {
    if(hasRightSpaceOnWindow && hasLeftSpaceOnWindow) return 'center';

    if(hasLeftSpaceOnWindow) return 'left';

    return 'right';
  };

  const horizontalPosition = {
    center: minLeft,
    right: realBoundRight - (arrowWidth / 2),
    left: realBoundLeft - stopHoverWidth + (arrowWidth / 2),
  }

  return {
    left: horizontalPosition[hoverAlign()],
    top: hoverSide === 'top' ? topPosition : bottomPosition,
    align: hoverAlign(),
    side: hoverSide,
  }
}
